import { Injectable } from "@angular/core";
import { AffiliateService } from "@deltager/organizers/admin/core/services/affiliate.service";

@Injectable()
export class CultureCode extends String {
  constructor(private affiliateService: AffiliateService) {
    super();
  }

  toString() {
    return this.affiliateService.settings.cultureCode;
  }
}
